import * as z from "zod";
import {
  dateSchema,
  referenceObject,
  requiredString,
} from "components/form/utils";

export const ticketSchema = z.object({
  title: requiredString().nonempty("Title cannot be empty"),
  description: requiredString().nonempty("Description cannot be empty"),
  attachments: z.array(z.any()).optional(),
  // assigned_to: referenceObject(),
  status: z.optional(z.string()).default("open"),
  priority: requiredString(),
  type: requiredString(),
  due_date: dateSchema.optional().nullable(),
  // response: z.optional(z.string()).nullable(),
});
